
import React, { useEffect, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper,
    useMediaQuery, Button, FormHelperText, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Checkbox, Autocomplete, Radio, RadioGroup, FormControlLabel, FormLabel, TextareaAutosize,
    Typography
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import Titlebar from '../TitleBar';
import styled, { cutDates, inputStyles, stockNumber, inputNumbersmall, inputStyle11 } from '../../Utils/inputChanges';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentDate } from '../../Utils/Dateutils';
import { errorStyles } from '../../Utils/table';
import axios from 'axios';
import Dropdown from '../FieldsComponents/Dropdown';
import DateInputComponent from '../FieldsComponents/DateInputComponent';
import Preview from '@mui/icons-material/Preview';
import PreviewIcon from '@mui/icons-material/Preview';
import DeleteIcon from '@mui/icons-material/Delete';
import DropdownWithBtn from '../FieldsComponents/DropdownWithBtn';
import { AdminSaleMenu, onlyAdminSaleMenu } from '../TitleList';
import { fetchZoneData } from '../../Store/PHPSlice/zone';
import { selectlocationdata, selectStkInwdata, selectStockItems, selectZones } from '../Selectors/Master/OutwardSelectors';
import { fetchStkInwData, fetchStockItemlist } from '../../Store/PHPSlice/StkInw';
import { insertAdminSaleEntry } from '../../Store/PHPSlice/stockApi';
import DateInputComponent2 from '../FieldsComponents/DateInputComponent2';
import RadioComponent from '../FieldsComponents/RadioComponent';
import { fetchLocationData2 } from '../../Store/PHPSlice/LocationApi';
import { fetchCompanyData } from '../../Store/PHPSlice/Firm';
import { selectFirm } from '../Selectors/Master/ItemSelectors';



const AdminSaleEntry = () => {

    const userdata = JSON.parse(sessionStorage.getItem('user'));
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [selectedRows, setSelectedRows] = useState(new Set());
    const [formData, setFormData] = useState({
        dt: getCurrentDate(),
        billNo: '',
        firm: '',
        zone: '',
        loc: '',
        item: '',
        totIssqty: '0',
        totqty: '0',
        totprate: '0',
        totsrate: '0',
        totIssqty2: '0',
        totqty2: '0',
        totprate2: '0',
        totsrate2: '0',
        totamt: '0',
        totamt2: '0',
        freight_ch: '0',
        other_ch: '0',
        grandtot: '',
        gst_type: 'no',
        gst: '0',
        igst: '0',
        cgst: '0',
        sgst: '0',
        state_type: '',
        discnt_type: 'percent',
        discnt_amt: '0',
        discnt_val: '0',
        netamt: '0',
        trans: '',
        remark: '',
        shipto: '',
        shipadrs: '',
        nocart: '',
        userId: userdata?.ID
    });
    const [locdata, setLocdata] = useState([]);
    const [openDropdowns, setOpenDropdowns] = useState({});
    const actionMap = {

        // Add more mappings if needed
    };
    const [activeMenu, setActiveMenu] = useState(AdminSaleMenu);
    const [tableData, setTableData] = useState([]);
    const [multiItems, setMultiItems] = useState([]);
    const dispatch = useDispatch();
    const memoNo = [];
    const partyList = [];
    const itemList = [];
    const zonedata = useSelector(selectZones);
    const stkdata = useSelector(selectStockItems);
    const loclist = useSelector(selectlocationdata);
    const firmlist = useSelector(selectFirm);
    // console.log(masterMlist)

    useEffect(() => {
        dispatch(fetchZoneData());
        dispatch(fetchStockItemlist());
        dispatch(fetchLocationData2());
        dispatch(fetchCompanyData());
        fetchAdsaleMemo();
        Object.keys(openDropdowns).forEach((dropdown) => {
            if (openDropdowns[dropdown]) {
                const action = actionMap[dropdown];
                if (action) {
                    dispatch(action());
                }
            }
        });
    }, [openDropdowns, dispatch]);

    useEffect(() => {
        if (memoNo.data) {
            const item = memoNo.data.memo;
            setFormData(prev => ({
                ...prev,
                memo: item
            }))
        }
    }, [memoNo]);

    useEffect(() => {
        if (!userdata) return;


        if (userdata?.pageIds?.length > 0 && userdata?.role !== '1') {
            const pid = userdata?.pageIds?.find(item => item === 1);
            if (pid === 1 && userdata?.role === '3') {
                setActiveMenu(onlyAdminSaleMenu);
                // console.log('hhi')
            } else {
                setActiveMenu(AdminSaleMenu);
            }

        }
    }, []);


    useEffect(() => {
        if (tableData?.length > 0) {
            const prev_totamt = multiItems?.reduce((acc, sum) => acc + parseFloat(sum.totamt || 0), 0);
            const totamt = tableData?.reduce((acc, sum) => acc + parseFloat(sum.saleamt || 0), 0);
            const final_totamt = prev_totamt + totamt;

            if (formData.gst_type === '1') {
                const discnt_amt = Math.round((parseFloat(formData.discnt_val) / 100) * parseFloat(final_totamt));
                let grandtot = parseFloat(final_totamt) - discnt_amt;
                let cgst, igst, sgst;
                let gst_val = Math.round(grandtot * (parseFloat(formData.gst !== '' ? formData.gst : 5) / 100));
                if (formData.state_type === '1') {
                    igst = gst_val;
                } else {
                    const half_gst = Math.round(gst_val / 2).toFixed(2);
                    cgst = half_gst;
                    sgst = half_gst;
                }
                setFormData(prev => ({
                    ...prev,
                    totamt: final_totamt || 0,
                    discnt_amt: discnt_amt || 0,
                    grandtot: grandtot || 0,
                    totamt2: totamt || 0,
                    gst_val: gst_val,
                    igst: igst || 0,
                    cgst: cgst || 0,
                    sgst: sgst || 0
                }));
            } else {

                let grandtot = parseFloat(final_totamt);
                let cgst, igst, sgst;
                let gst_val = Math.round(grandtot * (parseFloat(formData.gst) / 100));
                if (formData.state_type === '1') {
                    igst = gst_val;
                } else {
                    const half_gst = Math.round(gst_val / 2).toFixed(2);
                    cgst = half_gst;
                    sgst = half_gst;
                }
                setFormData(prev => ({
                    ...prev,
                    totamt: final_totamt || 0,
                    grandtot: grandtot || 0,
                    totamt2: totamt || 0,
                }));
            }
        }
    }, [tableData]);

    const gstField = [
        { label: 'GST(%)', name: 'gst' },
    ];

    const options_gst = [
        { value: 'yes', label: 'Yes' },
        { value: 'no', label: 'No' },
    ];

    const opts_discnt_amt = [
        { value: 'percent', label: '%' },
        { value: 'rupees', label: 'Rs.' },
    ];

    const fields2 = [
        { label: 'Total Amount', name: 'totamt', type: 'readOnly' },
        { label: 'Freight Charges', name: 'freight_ch' },
    ];

    const fields21 = [
        { label: 'Other Charges', name: 'other_ch' },
        { label: 'Gross Total', name: 'grandtot', type: 'readOnly' }
    ];

    const fields4 = [
        { label: 'IGST', name: 'igst', type: 'readOnly' },
        { label: 'CGST', name: 'cgst', type: 'readOnly' },
        { label: 'SGST', name: 'sgst', type: 'readOnly' },
        { label: 'Grand Total', name: 'netamt', type: 'readOnly' }
    ];

    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement

    const handleDropdownOpen = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: true }));
    };

    const handleDropdownClose = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: false }));
    };

    const fetchSchlZoneWise = async (id) => {
        try {
            const response = await axios.get(`${baseUrl}?apicall=getZonewiseSchl&zoneId=${id}`);
            setLocdata(response.data.data);
            // console.log(response?.data);
        } catch (error) {
            console.error('Error fetching info list:', error);
        }
    };

    const fetchAdsaleMemo = async () => {
        try {
            const response = await axios.get(`${baseUrl}?apicall=getAdsaleMemo`);
            const memos = response?.data?.data;
            setFormData(prev => ({
                ...prev,
                billNo: memos?.memo
            }));
        } catch (error) {
            console.error('Error fetching info list:', error);
        }
    };

    const fetchItemlistStkInw = async (id) => {
        const { stkId, itemId } = id;
        try {
            // const response = await axios.get(`${baseUrl}?apicall=getStkDataItemWise&stkId=${stkId}&itemId=${itemId}`);
            const response = await axios.get(`${baseUrl}?apicall=getStockInwMergeItemWithSizes&itemId=${itemId}`);

            // console.log(response?.data);
            setTableData(response?.data?.info);
            const datas = response?.data?.info?.reduce((acc, sum) => acc + parseFloat(sum.bqty), 0);
            setFormData(prev => ({
                ...prev,
                totqty: parseFloat(prev.totqty) + parseFloat(datas || 0),
                totqty2: parseFloat(datas || 0),
                state_type: datas?.state_type
            }));
        } catch (error) {
            console.error('Error fetching info list:', error);
        }
    };

    const handleViewClick = (form) => {
        // Construct the URL with query parameters or use a placeholder route
        const url = `/admin-sale-view?form=${encodeURIComponent(JSON.stringify(form))}`;

        // Open the URL in a new tab
        window.open(url, '_blank', 'width=1000,height=600,scrollbars=yes,resizable=yes');
    };

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });
        switch (dropdownType) {
            case 'item':
                if (value) {
                    const selectitem = stkdata?.data?.filter((val) => val.ID === value);
                    // console.log(selectitem)
                    const data = {
                        stkId: selectitem?.map(val => val.id),
                        itemId: value
                    };
                    // console.log(data)
                    fetchItemlistStkInw(data);
                };
                break;
            case 'partyId':
                if (value) {
                    const state_type = partyList?.data?.find(item => item.ID === formData.partyId)?.state_type;
                    setFormData(prev => ({
                        ...prev,
                        state_type: state_type
                    }));
                }
                break;
            case 'discnt_val':
                if (value) {
                    let totalAmount = parseFloat(formData.totamt);
                    let discnt_amt, grandtot;
                    let other_ch = formData.other_ch !== '' ? parseFloat(formData.other_ch) : 0;
                    let freight_ch = formData.freight_ch !== '' ? parseFloat(formData.freight_ch) : 0;
                    if (formData.discnt_type == 'percent') {
                        discnt_amt = Math.round((parseFloat(value) / 100) * totalAmount);
                        grandtot = totalAmount - discnt_amt + other_ch + freight_ch;
                    } else if (formData.discnt_type == 'rupees') {
                        discnt_amt = parseFloat(value);
                        grandtot = totalAmount - discnt_amt + other_ch + freight_ch;
                    }

                    let igst = 0, cgst = 0, sgst = 0;
                    let cal_grand = Math.round(parseFloat(grandtot) / parseFloat(formData.gst));
                    if (formData.state_type == '1') {
                        igst = cal_grand;
                    } else {
                        const half_grand = (cal_grand / 2).toFixed(2);
                        cgst = half_grand;
                        sgst = half_grand;
                    }
                    let final_grand_tot = Math.round(parseInt(grandtot, 10) + parseInt(cal_grand, 10));
                    setFormData(prev => ({
                        ...prev,
                        discnt_amt: discnt_amt,
                        grandtot: grandtot,
                        igst: igst || 0,
                        cgst: cgst || 0,
                        sgst: sgst || 0,
                        netamt: final_grand_tot
                    }));
                }
                break;
            // case 'loc':
            //     if (value && formData.zone !== '') {
            //         const data = {
            //             zoneId: formData.zone,
            //             locId: value
            //         };
            //         fetchSchlZoneWise(data);
            //     };
            //     break;

            case 'zone':
                if (value) {
                    fetchSchlZoneWise(value);
                };
                break;

            default:
                break;
        }
    };

    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
        switch (name) {
            case 'discnt_val':
                if (value) {
                    let totalAmount = parseFloat(formData.totamt);
                    let discnt_amt, grandtot;
                    let other_ch = formData.other_ch !== '' ? parseFloat(formData.other_ch) : 0;
                    let freight_ch = formData.freight_ch !== '' ? parseFloat(formData.freight_ch) : 0;
                    const updatedData = [...tableData];
                    const cal_data = updatedData?.map((item) => {
                        const discal = Math.round((parseFloat(value) / 100) * item?.srate);
                        const disrate = parseFloat(item?.srate) - parseFloat(discal);
                        return {
                            ...item,
                            disrate: disrate
                        };
                    });
                    setTableData(cal_data);
                    if (formData.discnt_type == 'percent') {
                        discnt_amt = Math.round((parseFloat(value) / 100) * totalAmount);
                        grandtot = totalAmount - discnt_amt + other_ch + freight_ch;
                    } else if (formData.discnt_type == 'rupees') {
                        discnt_amt = parseFloat(value);
                        grandtot = totalAmount - discnt_amt + other_ch + freight_ch;
                    }

                    let igst = 0, cgst = 0, sgst = 0;
                    let cal_grand = Math.round(parseFloat(grandtot) * (parseFloat(formData.gst) / 100));
                    if (formData.state_type == '1') {
                        igst = cal_grand;
                    } else {
                        const half_grand = (cal_grand / 2).toFixed(2);
                        cgst = half_grand;
                        sgst = half_grand;
                    }
                    let final_grand_tot = Math.round(parseInt(grandtot, 10) + parseInt(cal_grand, 10));
                    setFormData(prev => ({
                        ...prev,
                        discnt_amt: discnt_amt,
                        grandtot: grandtot,
                        igst: igst || 0,
                        cgst: cgst || 0,
                        sgst: sgst || 0,
                        netamt: final_grand_tot
                    }));
                }
                break;
        }
    };


    const handleRadioChange = (event) => {
        setFormData({
            ...formData,
            [event.target.name]: event.target.value,
        });

        if (event.target.value === 'yes') {
            const update_gross = parseInt(formData.totamt, 10) - parseInt(formData.discnt_amt, 10) + parseInt(formData.freight_ch, 10) + parseInt(formData.other_ch, 10);
            // console.log(update_gross)
            let igst = 0, cgst = 0, sgst = 0, gst = 5;
            let cal_grand = Math.round(parseFloat(update_gross) * (parseFloat(gst) / 100));
            if (formData.state_type == '1') {
                igst = cal_grand;
            } else {
                const half_grand = (cal_grand / 2).toFixed(2);
                cgst = half_grand;
                sgst = half_grand;
            }
            let final_grand_tot = Math.round(parseInt(update_gross, 10) + parseInt(cal_grand, 10));

            setFormData(prevFormData => ({
                ...prevFormData,
                grandtot: update_gross,
                igst: igst || 0,
                cgst: cgst || 0,
                sgst: sgst || 0,
                netamt: final_grand_tot,
                gst: gst
            }));

        }
        if (event.target.value === 'no') {
            const gross_tot = parseInt(formData.totamt, 10) - parseInt(formData.discnt_amt, 10);
            const update_gross = parseInt(gross_tot, 10) + parseInt(formData.freight_ch, 10) + parseInt(formData.other_ch, 10);
            let igst = 0, cgst = 0, sgst = 0;
            let cal_grand = Math.round(parseFloat(update_gross) * (parseFloat(formData.gst) / 100));
            if (formData.state_type == '1') {
                igst = 0;
            } else {
                cgst = 0;
                sgst = 0;
            }
            let final_grand_tot = 0;

            setFormData(prevFormData => ({
                ...prevFormData,
                grandtot: update_gross,
                igst: igst || 0,
                cgst: cgst || 0,
                sgst: sgst || 0,
                netamt: final_grand_tot,
                gst: '0'
            }));
        }
    };

    const handleInputComplete = (e) => {
        const { name, value } = e.target;

        switch (name) {
            case 'gst':
                if (value) {
                    const total_amt = parseInt(formData.totamt, 10);
                    const gst_amt = Math.round(total_amt * (parseFloat(formData.discnt_val) / 100));
                    const grandtot2 = Math.round(total_amt - gst_amt + parseFloat(formData.other_ch) + parseFloat(formData.freight_ch));

                    let igst = 0, cgst = 0, sgst = 0, netamt = 0;
                    if (formData.state_type == '1') {
                        igst = Math.round(grandtot2 * parseFloat(value) / 100);
                        netamt = igst + grandtot2;
                    } else {
                        const diff = Math.round(grandtot2 * parseFloat(value) / 100);
                        cgst = Math.round(diff / 2);
                        sgst = Math.round(diff / 2);
                        netamt = diff + grandtot2;
                    }

                    setFormData(prev => ({
                        ...prev,
                        igst: igst || 0,
                        cgst: cgst || 0,
                        sgst: sgst || 0,
                        netamt: netamt
                    }));
                }
                break;

            case 'freight_ch':
                if (value) {
                    const total_amt = parseInt(formData.totamt, 10);
                    const gst_amt = Math.round(total_amt * (parseFloat(formData.discnt_val) / 100));
                    const grandtot2 = Math.round(total_amt - gst_amt);
                    const other_ch = formData.other_ch !== '' ? parseFloat(formData.other_ch) : 0;
                    let final_grand = grandtot2 + parseFloat(value) + other_ch;
                    setFormData(prev => ({
                        ...prev,
                        grandtot: final_grand
                    }));
                    if (formData.gst_type === 'yes') {
                        let gst_cal, igst, cgst, sgst;

                        gst_cal = Math.round(final_grand * (parseFloat(formData.gst) / 100));

                        if (formData.state_type == '1') {
                            igst = gst_cal;
                        } else {
                            cgst = Math.round(gst_cal / 2);
                            sgst = Math.round(gst_cal / 2);
                        }

                        let netamt = final_grand + gst_cal;
                        setFormData(prev => ({
                            ...prev,
                            grandtot: final_grand,
                            igst: igst || 0,
                            cgst: cgst || 0,
                            sgst: sgst || 0,
                            netamt: netamt
                        }));

                    }
                }
                break;
            case 'other_ch':
                if (value) {

                    const total_amt = parseInt(formData.totamt, 10);
                    const gst_amt = Math.round(total_amt * (parseFloat(formData.discnt_val) / 100));
                    const grandtot2 = Math.round(total_amt - gst_amt);
                    const freight_ch = formData.freight_ch !== "" ? parseFloat(formData.freight_ch) : 0;
                    const final_grand = grandtot2 + parseFloat(value) + freight_ch;

                    if (formData.gst_type === 'yes') {
                        let gst_cal = parseFloat((final_grand * (parseFloat(formData.gst) / 100)).toFixed(2));
                        let igst = 0, cgst = 0, sgst = 0;

                        if (formData.state_type === '1') {
                            igst = gst_cal;
                        } else {
                            cgst = parseFloat((gst_cal / 2).toFixed(2));
                            sgst = parseFloat((gst_cal / 2).toFixed(2));
                        }

                        let netamt = Math.round((final_grand + gst_cal))
                        setFormData(prev => ({
                            ...prev,
                            grandtot: final_grand,
                            igst: igst,
                            cgst: cgst,
                            sgst: sgst,
                            netamt: netamt
                        }));
                    } else {
                        setFormData(prev => ({
                            ...prev,
                            grandtot: final_grand
                        }));
                    }

                }
                break;

        }
    }

    const handleChange = (index, field, value) => {
        const filterData = tableData?.filter(item => item.bqty !== '0');
        const updatedData = [...filterData];

        if (field === 'qty') {
            const prevQty = parseFloat(updatedData[index][field] || 0);
            const newQty = parseFloat(value || 0);

            // Update the quantity first
            updatedData[index][field] = newQty;
            setTableData(updatedData);

            // Update the total quantity
            setFormData(prev => ({
                ...prev,
                totQty: parseFloat(prev.totQty) - prevQty + newQty
            }));
        }

        if (field === 'prate') {
            const prevPrate = parseFloat(updatedData[index][field] || 0);
            const newPrate = parseFloat(value || 0);

            // Update the quantity first
            updatedData[index][field] = newPrate;
            setTableData(updatedData);

            // Update the total quantity
            setFormData(prev => ({
                ...prev,
                totprate: parseFloat(prev.totprate) - prevPrate + newPrate
            }));
        }

        if (field === 'srate') {
            const prevSrate = parseFloat(updatedData[index][field] || 0);
            const newQSrate = parseFloat(value || 0);

            // Update the quantity first
            updatedData[index][field] = newQSrate;
            setTableData(updatedData);

            // Update the total quantity
            setFormData(prev => ({
                ...prev,
                totsrate: parseFloat(prev.totsrate) - prevSrate + newQSrate
            }));
        }

        if (field === 'color') {
            updatedData[index][field] = value;
            setTableData(updatedData);
        }
        if (field === 'issqty') {
            const enteredQty = parseFloat(value || 0);
            const availableQty = parseFloat(updatedData[index].bqty || 0);
            const prevSrate = parseFloat(updatedData[index][field] || 0);
            const disrate = parseFloat(updatedData[index].disrate || 0);
            if (enteredQty > availableQty) {
                alert("Issued quantity cannot be greater than available quantity (bqty).");
                return; // Don't update the state
            }
            const samt = disrate * enteredQty;
            const balqty = availableQty - enteredQty;
            updatedData[index][field] = enteredQty;
            updatedData[index].saleamt = samt;
            updatedData[index].balqty = balqty;
            setTableData(updatedData);
            const totissqty = updatedData?.reduce((acc, sum) => acc + parseFloat(sum.issqty), 0);
            const prevIss = multiItems?.reduce((acc, sum) => acc + parseFloat(sum.totIssqty), 0);
            // Update the total quantity
            setFormData(prev => ({
                ...prev,
                totIssqty: parseFloat(prevIss) + totissqty,
                totIssqty2: totissqty,
            }));
        }

    };

    const handleMultiItems = () => {
        const selectItem = stkdata?.data?.find(val => val.ID === formData.item);
        const stkId = selectItem?.id;
        const itemNm = selectItem?.itemNm;
        const datas = {
            itemId: formData.item,
            itemNm: itemNm,
            stkId: stkId,//stkId
            info: tableData,
            totqty: formData.totqty2,
            totIssqty: formData.totIssqty2,
            totprate: formData.totprate2,
            totsrate: formData.totsrate2,
            totamt: formData.totamt2
        };
        setMultiItems(prev => [...prev, datas]);
        setFormData(prev => ({
            ...prev,
            item: '',
            totIssqty2: '0',
            totqty2: '',
            totprate2: '',
            totsrate2: '',
            totamt2: '0'
        }));
        setTableData([]);
    };

    const tableContainerStyle = {
        marginTop: '1%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',
        overflowY: 'hidden',
        WebkitOverflowScrolling: 'touch',
    };


    function convertIntoOneObject(formData, multiItems) {
        const totamt = formData.netamt !== '0' ? formData.netamt : formData.grandtot;
        const discnt_type = formData.discnt_type === 'percent' ? '%' : 'Rs';
        // const discnt_type = formData.discnt_type;
        const gst_type = formData.gst_type === 'yes' ? '1' : '0';
        const data = {
            dt: formData.dt,
            billNo: formData.billNo,
            firmId: formData.firm,
            zone: formData.zone,
            loc: formData.loc,
            schlId: formData.schlId,
            totamt: formData.totamt,
            discnt_type: discnt_type,
            discnt_val: formData.discnt_val,
            discnt_amt: formData.discnt_amt,
            freight_ch: formData.freight_ch,
            other_ch: formData.other_ch,
            party_state: formData.state_type,
            gst: gst_type,
            gst_val: formData.gst,
            igst: formData.igst,
            cgst: formData.cgst,
            sgst: formData.sgst,
            netamt: totamt,
            totqty: formData.totqty,
            userId: formData.userId,
            totIssqty: formData.totIssqty,
            shipto: formData.shipto,
            shipadrs: formData.shipadrs,
            trans: formData.trans,
            remark: formData.remark,
            multiItems: multiItems,
            nocart: formData.nocart
        };
        return data;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (formData.billNo === '') {
            alert('Please Enter Bill No.');
            return; // Stop form submission
        }

        if (formData.firm === '') {
            alert('Please Select Firm.');
            return; // Stop form submission
        }
        const postObj = convertIntoOneObject(formData, multiItems);
        // console.log(postObj);

        dispatch(insertAdminSaleEntry(postObj))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                alert("Admin Sale Added");
                window.location.reload();
                // You may want to update your component state or perform any other action
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });

    };

    const dropdownOrdType = [
        {
            label: 'Firm',
            id: 'firm',
            options: firmlist?.data || [],
            value: formData.firm,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'firm', value: newValue ? newValue.ID : '' } }, 'firm'),
            getOptionLabel: (option) => option.firmNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            bold: true
        },
        {
            label: 'Zone',
            id: 'zone',
            options: zonedata?.data || [],
            value: formData.zone,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'zone', value: newValue ? newValue.ID : '' } }, 'zone'),
            getOptionLabel: (option) => option.zoneNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            bold: true
        },
        // {
        //     label: 'Location',
        //     id: 'loc',
        //     options: loclist?.data || [],
        //     value: formData.loc,
        //     onChange: (newValue) => handleDropdownChange({ target: { name: 'loc', value: newValue ? newValue.ID : '' } }, 'loc'),
        //     getOptionLabel: (option) => option.locNm || '',
        //     isOptionEqualToValue: (option, value) => option.ID === value.ID,
        //     valueFinder: (options, value) => {
        //         if (Array.isArray(options)) {
        //             return options.find(item => item.ID === value) || null;
        //         }
        //         return null;
        //     },
        //     bold: true
        // },
        {
            label: 'School',
            id: 'schlId',
            options: locdata || [],
            value: formData.schlId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'schlId', value: newValue ? newValue.ID : '' } }, 'schlId'),
            getOptionLabel: (option) => `${option.schlcd}-${option.schlNm}`,
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            bold: true
        },
        {
            label: 'Item',
            id: 'item',
            options: stkdata?.data?.filter(item => !multiItems.some(val => val.itemId === item.ID)) || [],
            value: formData.item,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'item', value: newValue ? newValue.ID : '' } }, 'item'),
            getOptionLabel: (option) => option.itemNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            bold: true
        }
    ];

    const handleCheckboxChange = (index) => {
        setSelectedRows(prevSelectedRows => {
            const newSelectedRows = new Set(prevSelectedRows);
            if (newSelectedRows.has(index)) {
                newSelectedRows.delete(index);
            } else {
                newSelectedRows.add(index);
            }
            return newSelectedRows;
        });
    };

    const handleRemoveSelected = () => {
        setMultiItems(prevFormArray =>
            prevFormArray.filter((_, index) => !selectedRows.has(index))
        );
        setSelectedRows(new Set()); // Clear selection after removal
    };
    // console.log(formData)

    return (
        <>
            <Titlebar data={activeMenu} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Admin Sale Entry</h2>

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>

                                {[
                                    { label: 'Date', name: 'dt', type: 'date' },
                                    { label: 'Bill No', name: 'billNo', type: 'readOnly' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={handleDateChange}
                                                            inputProps={{ style: styled.cutDate }}
                                                            sx={cutDates}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name]}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input, readOnly: field.type }}
                                                            sx={cutDates}
                                                        />
                                                    )}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}



                                {
                                    dropdownOrdType?.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here

                                        />
                                    ))
                                }


                                {[
                                    { label: 'Transport', name: 'trans' },
                                    { label: 'Remark', name: 'remark' },
                                    { label: 'Ship To', name: 'shipto' },
                                    { label: 'Ship Address', name: 'shipadrs' },
                                    { label: 'No of Cartoons', name: 'nocart' },
                                    { label: 'Total Given Qty', name: 'totqty', type: 'readOnly' },
                                    { label: 'Total Issue Qty', name: 'totIssqty', type: 'readOnly' },

                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={handleDateChange}
                                                            inputProps={{ style: styled.cutDate }}
                                                            sx={cutDates}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name]}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input, readOnly: field.type }}
                                                            sx={cutDates}
                                                        />
                                                    )}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                <RadioComponent
                                    label='GST'
                                    name='gst_type'
                                    value={formData.gst_type}
                                    options={options_gst}
                                    onChange={handleRadioChange}
                                    isDesktop={true}
                                />

                                {formData.gst_type === 'yes' ?

                                    <>
                                        {gstField.map((field) => (
                                            <DateInputComponent2
                                                key={field.name}
                                                formData={formData}
                                                handleDateChange={handleDateChange}
                                                handleInputChange={handleInputChange}
                                                styled={styled}
                                                inputStyles={inputStyles}
                                                isDesktop={isDesktop}
                                                field={field}
                                                handleInputComplete={handleInputComplete}
                                            />
                                        ))}
                                    </>
                                    : (
                                        <Grid item xs={12} md={6}>
                                        </Grid>
                                    )
                                }


                                {fields2.map((field) => (
                                    <DateInputComponent2
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                        handleInputComplete={handleInputComplete}
                                    />
                                ))}

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel htmlFor="discnt_amt">Discount Amount:</InputLabel>
                                            <RadioGroup row name="discnt_type" value={formData.discnt_type} onChange={handleRadioChange}>
                                                {opts_discnt_amt.map((option) => (
                                                    <FormControlLabel
                                                        key={option.value}
                                                        value={option.value}
                                                        control={<Radio />}
                                                        label={option.label}
                                                    />
                                                ))}
                                                {/* <input type="text" name='discnt_val' value={formData.discnt_val} onChange={handleInputChange}
                                                    style={{ width: '50px', height: '25px', paddingLeft: '5px', marginTop: '1px', color: 'red', fontSize: '15px' }} /> */}
                                            </RadioGroup>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth style={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
                                                <TextField
                                                    id="discnt_val"
                                                    name="discnt_val"
                                                    value={formData.discnt_val}
                                                    onChange={handleInputChange}
                                                    inputProps={{ style: styled.inputs }}
                                                    sx={inputNumbersmall}
                                                />
                                                <TextField
                                                    id="discnt_amt"
                                                    name="discnt_amt"
                                                    value={formData.discnt_amt}
                                                    onChange={handleInputChange}
                                                    inputProps={{ style: styled.input, readOnly: true }}
                                                    sx={inputStyle11}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {fields21.map((field) => (
                                    <DateInputComponent2
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                        handleInputComplete={handleInputComplete}
                                    />
                                ))}

                                {formData.gst_type === 'yes' &&
                                    <>
                                        {
                                            fields4.map((field) => (
                                                <DateInputComponent
                                                    key={field.name}
                                                    formData={formData}
                                                    handleDateChange={handleDateChange}
                                                    handleInputChange={handleInputChange}
                                                    styled={styled}
                                                    inputStyles={inputStyles}
                                                    isDesktop={isDesktop}
                                                    field={field}
                                                />
                                            ))
                                        }
                                    </>

                                }


                                {Array.isArray(tableData) && tableData.length > 0 &&
                                    <>
                                        <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                            <Table>
                                                <TableBody>

                                                    <TableRow>

                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Size</TableCell>

                                                        {tableData?.filter(item => item.bqty !== "0")
                                                            ?.map((item, index) => (
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>{item.size}</TableCell>
                                                            ))}

                                                    </TableRow>

                                                    {/* <TableRow>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Color</TableCell>
                                                        {tableData?.filter(item => item.bqty !== "0")
                                                            ?.map((item, index) => (
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>
                                                                    {item.color}
                                                                </TableCell>
                                                            ))}
                                                    </TableRow> */}

                                                    <TableRow>

                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Stock Qty</TableCell>

                                                        {tableData?.filter(item => item.bqty !== "0")
                                                            ?.map((item, index) => (
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>
                                                                    {item.bqty}
                                                                </TableCell>
                                                            ))}

                                                    </TableRow>

                                                    <TableRow>

                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Issue Qty</TableCell>

                                                        {tableData?.filter(item => item.bqty !== "0")
                                                            ?.map((item, index) => (
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>
                                                                    <input type="text"
                                                                        value={item.issqty || ''}
                                                                        name='issqty'
                                                                        onChange={(e) => handleChange(index, 'issqty', e.target.value)}
                                                                        style={{ height: '25px', width: '60px' }}
                                                                    />
                                                                </TableCell>
                                                            ))}

                                                    </TableRow>
                                                    <TableRow>

                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Bal Qty.</TableCell>

                                                        {tableData?.filter(item => item.bqty !== "0")
                                                            ?.map((item, index) => (
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>
                                                                    {item.balqty}
                                                                </TableCell>
                                                            ))}

                                                    </TableRow>
                                                    <TableRow>

                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Purchase Price</TableCell>

                                                        {tableData?.map((item, index) => (
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>
                                                                {item.prate}
                                                            </TableCell>
                                                        ))}

                                                    </TableRow>
                                                    <TableRow>

                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Sale Price</TableCell>

                                                        {tableData?.filter(item => item.bqty !== "0")
                                                            ?.map((item, index) => (
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>
                                                                    {item.srate}
                                                                </TableCell>
                                                            ))}

                                                    </TableRow>
                                                    <TableRow>

                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Discount Sale Price</TableCell>

                                                        {tableData?.filter(item => item.bqty !== "0")
                                                            ?.map((item, index) => (
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>
                                                                    {item.disrate}
                                                                </TableCell>
                                                            ))}

                                                    </TableRow>

                                                    <TableRow>

                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Amt</TableCell>

                                                        {tableData
                                                            ?.filter(item => item.bqty !== "0")
                                                            ?.map((item, index) => (
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>
                                                                    {item.saleamt}
                                                                </TableCell>
                                                            ))}

                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                        </TableContainer>


                                        <Grid item xs={12} textAlign="center" style={{ display: 'flex', justifyContent: 'space-around' }}>
                                            <Button variant="contained" color="primary" onClick={handleMultiItems}>Add</Button>

                                        </Grid>
                                    </>
                                }

                                <Button variant="contained" color="primary" onClick={handleRemoveSelected}>Delete</Button>

                                {multiItems.length > 0 &&
                                    <TableContainer
                                        style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}
                                    >
                                        <Table>
                                            <TableHead>
                                                <TableRow className='tbl-row'>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Select.</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Sr.No.</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Item</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Total Stock Qty.</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Total Issue Qty.</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Total Amt</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>View</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {multiItems.length > 0
                                                    ? multiItems?.map((form, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>
                                                                <Checkbox
                                                                    checked={selectedRows?.has(index)}
                                                                    onChange={() => handleCheckboxChange(index)}
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{index + 1}</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.itemNm}</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.totqty}</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.totIssqty}</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.totamt}</TableCell>

                                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>
                                                                <PreviewIcon className='cursor-pointer' onClick={() => handleViewClick(form)} />
                                                            </TableCell>
                                                        </TableRow>
                                                    ))
                                                    : ''}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                }


                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit}>Submit</Button>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                </Grid>
            </div>

        </>
    );
}

export default AdminSaleEntry;
